import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {SoftNavOnlyLink as Link} from '@github-ui/react-router'
import {ArrowLeftIcon} from '@primer/octicons-react'
import {Heading} from '@primer/react'
import type {ReactNode} from 'react'

import styles from './RepositoryMilestone.module.css'

export function MilestoneTitleData({
  title,
  nameWithOwner,
  children,
}: {
  title: string
  nameWithOwner: string
  children?: ReactNode
}) {
  const milestonesPath = `/${nameWithOwner}/milestones`

  return (
    <div className={styles.milestoneTitleWrapper}>
      <Link to={milestonesPath} className={styles.backLink}>
        {/* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */}
        <ArrowLeftIcon />
        Back to Milestones
      </Link>
      <div className={`${styles.buttonGrp} ${styles.header}`}>
        <div className={styles.titleGroup}>
          <SidebarPageLayout.SidebarTrigger />
          <Heading className={styles.title} as="h2">
            {title}
          </Heading>
        </div>
        {children ? <div className={styles.actionsGrp}>{children}</div> : null}
      </div>
    </div>
  )
}
